// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"8d0e909e","29":"187a367c","287":"bd1f1b92","389":"a0c48c3d","475":"1e12166b","487":"52236d2d","535":"8ffd1ad7","644":"f5b40ef2","682":"bf5cf859","723":"1146466e","744":"2a73f477","856":"5e157ceb","885":"bb3229ba"}[chunkId] + ".chunk.js";
};